/**
 * Centralized API endpoint constants
 *
 * This file contains all API endpoints used throughout the application.
 * Using constants prevents typos and makes refactoring easier.
 */
export const API_ENDPOINTS = {
  // Authentication endpoints
  AUTH: {
    LOGIN: '/api/auth/login',
    REFRESH: '/api/auth/refresh',
    LOGOUT: '/api/auth/logout',
    INITIATE_PASSWORD_RESET: '/api/auth/initiate/password/reset',
    VERIFY_PASSWORD_RESET_TOKEN: '/api/auth/password/reset/verify-token',
    PASSWORD_RESET: '/api/auth/password/reset',
  },

  // User endpoints
  USERS: {
    ME: '/api/v1/users/me',
    LIST: '/api/v1/users',
    CREATE: '/api/v1/users',
    UPDATE: '/api/v1/users',
    MANAGEABLE_ROLES: '/api/v1/users/me/roles/manageable',
    DELETE: (id: number) => `/api/v1/users/${id}`,
    REACTIVATE: (id: number) => `/api/v1/users/${id}/reactivate`,
    PROFILE: {
      UPDATE: '/api/v1/users/me/profile',
    },
    PHOTO: {
      UPDATE: '/api/v1/users/me/profile/photo',
      DELETE: '/api/v1/users/me/profile/photo',
    },
    PASSWORD: {
      UPDATE: '/api/v1/users/me/password',
    },
  },

  // Store endpoints
  STORES: {
    LIST: '/api/v1/stores',
    CREATE: '/api/v1/stores',
    UPDATE: '/api/v1/stores',
    DELETE: (id: number) => `/api/v1/stores/${id}`,
    BULK_DELETE: '/api/v1/stores/bulk',
    BULK_REACTIVATE: '/api/v1/stores/bulk/reactivate',
    REACTIVATE: (id: number) => `/api/v1/stores/${id}/reactivate`,
    EXPORT: '/api/v1/stores/export',
    UPLOAD: '/api/v1/stores/upload',
  },

  // Beneficiaries endpoints
  BENEFICIARIES: {
    LIST: '/api/v1/beneficiaries',
    CREATE: '/api/v1/beneficiaries',
    UPDATE: '/api/v1/beneficiaries',
    DELETE: (id: number) => `/api/v1/beneficiaries/${id}`,
    BULK_DELETE: '/api/v1/beneficiaries/bulk',
    BULK_REACTIVATE: '/api/v1/beneficiaries/bulk/reactivate',
    REACTIVATE: (id: number) => `/api/v1/beneficiaries/${id}/reactivate`,
    EXPORT: '/api/v1/beneficiaries/export',
    UPLOAD: '/api/v1/beneficiaries/upload',
  },

  // Segment endpoints
  SEGMENTS: {
    LIST: '/api/v1/segments',
    CREATE: '/api/v1/segments',
    UPDATE: '/api/v1/segments',
    DELETE: (id: number) => `/api/v1/segments/${id}`,
    REACTIVATE: (id: number) => `/api/v1/segments/${id}/reactivate`,
  },

  // Role endpoints
  ROLES: {
    SEGMENTS: '/api/v1/roles/segments',
  },
} as const;
